const GoogleBoxIcon = () => {
    return (
      <svg
        width="123"
        height="124"
        viewBox="0 0 123 124"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g filter="url(#filter0_d)">
          <rect x="22" y="13" width="79" height="79" rx="16" fill="white" />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M78.279 52.4088C78.279 51.1325 78.1644 49.9053 77.9517 48.7271H60.9996V55.6896H70.6865C70.2693 57.9395 69.0011 59.8458 67.0948 61.1222V65.6384H72.9119C76.3154 62.5048 78.279 57.8905 78.279 52.4088Z"
            fill="#4285F4"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M60.9984 69.9991C65.8582 69.9991 69.9326 68.3873 72.9107 65.6383L67.0936 61.1221C65.4818 62.2021 63.4201 62.8402 60.9984 62.8402C56.3103 62.8402 52.3423 59.674 50.9269 55.4196H44.9135V60.083C47.8752 65.9656 53.9622 69.9991 60.9984 69.9991Z"
            fill="#34A853"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M50.9279 55.4205C50.5679 54.3405 50.3634 53.1869 50.3634 52.0006C50.3634 50.8143 50.5679 49.6607 50.9279 48.5807V43.9173H44.9145C43.6954 46.3472 43 49.0962 43 52.0006C43 54.9051 43.6954 57.6541 44.9145 60.084L50.9279 55.4205Z"
            fill="#FBBC05"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M60.9984 41.1588C63.641 41.1588 66.0136 42.067 67.879 43.8506L73.0416 38.688C69.9244 35.7836 65.85 34 60.9984 34C53.9622 34 47.8752 38.0335 44.9135 43.916L50.9269 48.5795C52.3423 44.3251 56.3103 41.1588 60.9984 41.1588Z"
            fill="#EA4335"
          />
        </g>
        <defs>
          <filter
            id="filter0_d"
            x="0"
            y="0.698332"
            width="123"
            height="123"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            />
            <feOffset dy="9.69833" />
            <feGaussianBlur stdDeviation="11" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.35 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow"
              result="shape"
            />
          </filter>
        </defs>
      </svg>
    );
  };
  
  export default GoogleBoxIcon;
  